import { caseStepper as initialState } from '../initialState.tsx';
import {
  REQUEST_CASE_STEPPER,
  RECEIVE_CASE_STEPPER,
  ERROR_CASE_STEPPER,
} from 'typeConstants';

const caseStepper = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CASE_STEPPER:
      return {
        ...state,
        fetchingCaseStepper: true,
      };
    case RECEIVE_CASE_STEPPER:
      return {
        ...state,
        fetchingCaseStepper: false,
        trackerActive: action.payload.trackerFeatureEnabled,
        activeStep: action.payload.currentStatusRank,
        steps: action.payload.availableStatuses,
        isClosed: action.payload.isClosed,
      };
    case ERROR_CASE_STEPPER:
      return {
        ...state,
        fetchingCaseStepper: false,
        trackerActive: false,
        activeStep: -1,
        steps: [],
        isClosed: false,
      };
    default:
      return state;
  }
};

export default caseStepper;
